var map = {
	"./i7.png": "RxQi",
	"./i7en.png": "ZLor"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nHAm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet ^\.\/i7.*\.png$
// module id = nHAm
// module chunks = 0